<ng-template #videoElement>
  <video
    controls
    [title]="component()?.video?.description || component()?.video?.author || ''"
  >
    <source [src]="videoUrl()" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
</ng-template>
@if (videoUrl()) {
<ng-container *ngTemplateOutlet="videoElement"></ng-container>
}
